import React, { useState, useEffect } from "react";
import Tag from "../../../../generic/tag";
import OverflowButton from "../../../../generic/overflowButton";
import "../../../../../assets/scss/components/toc/orderBook/instruments/instrumentsDsk.scss";
import "../../../../../assets/scss/components/toc/orderBook/instruments/instrumentsTab.scss";
import {
  HObGroupBy,
  HOb2DGroupBy,
} from "../../../../service/orderBook/obGrpByHelper";
import Sort, { eSortState, sort } from "../../../../generic/sort";
import obtradeRowSelection from "../../../../service/orderBook/selectAll";
import indexer, { IListObj } from "../../../../types/genericTypes";
import { ICommodity } from "../../../../types/components/orderBook/obTypes";
import moment from "moment";
import dateTimeFormat from "../../../../service/dateTimeService";
import TocNoData from "../../../generic/tocNoData/tocNoData";
import { toINR } from "../../../../service/numberFormat";
import {
  ChipColorKeyComb,
  ovrOptions,
  scrlStCls,
  ObScrollStyle,
} from "../../obConstants";
import ObUtilHeader from "../../obContainer/obUtilHeader";
import DatePickerInt from "../../obContainer/obDatePickerInt";
import ObCheckbox from "../../generic/obCheckbox";
import ObAssetDetailPopup from "../../generic/obAssetDetailPopup";
import ObCommodityDtls from "../../obDetails/dsk/obCommodityDtls";
import { ChipStatusComb } from "./../../obConstants";
import {
  ACommCancelNrmTrd,
  ACommCancelAmoTrd,
} from "./../../../../service/orderBook/obApiService";
import ObToastMessPopup from "../../generic/obToastMessPopup";
import ee from "../../../../utils/eventEmitter";
import { SearchHighLight } from "../../../../service/generic/searchHighlight";
import EdButton from "../../../../generic/edButton";

export interface ObCommoditiesProps {
  // Array of Equity Data
  data: Array<any>;
  //true if table is history type else false
  isHistory?: boolean;
  hidePageNav?: (hide: boolean) => void;
  getDates: (frmDt: Date, toDate: Date) => void;
  reRenderCall?: (value: string) => void;
}

// heading for Commodities Asset table

const heading: indexer = {
  symbol: "Symbol",
  prodType: "Prod. Type",
  qty: "Qty.",
  orderPrice: "Order Price",
  avgPrice: "Avg. Price",
};

const sortKey: indexer = {
  symbol: "trdSym",
};

const ObCommodities: React.FC<ObCommoditiesProps> = (props) => {
  const ovrOpts: Array<IListObj> = ovrOptions;

  if (props.data.length) {
    for (let i = 0; i < props.data.length; i++) {
      var temp: Array<IListObj> = [];
      let dp: ICommodity = props.data[i];

      if (dp.edit === "true") {
        temp.push(ovrOpts[0]);
      }
      if (dp.cancel === "true") {
        temp.push(ovrOpts[1]);
      }
      if (dp.sts === "rejected") {
        temp.push(ovrOpts[3]);
      }
      if (dp.sts === "open" || (dp.sts === "pending" && dp.ogt === "AMO")) {
        temp.push(ovrOpts[2]);
      }
      dp["ovrOpts"] = temp;
    }
  }
  //selection handle start
  const [isSelectEnable, setIsSelectEnable] = useState(false);

  const [isAllDataSelected, setIsAllDataSelected] = React.useState(false);
  //selection handle end

  // wherever initial data needs to be sent, send initialData
  // initial data is array of array for supporting grouping
  const initialData = [
    props.data.map((data: any, index: number) => ({
      ...data,
      id: index,
      isSelected: false,
    })),
  ];

  // filteredData contains filtered, searched data
  let filteredData: Array<Array<{}>> = initialData;
  //executed orders count
  const exeCountRef = React.useRef();
  //Show Open Ords on Top or not ref state
  const OpenOrdsTopRef = React.useRef<boolean>();
  // tableData is shown in the table
  // tableData contains sorted, filtered, searched data
  let [tableData, setTableData] = useState<Array<Array<{}>>>(initialData);
  let CommHistoryData: Array<{ [x: string]: Array<ICommodity> }> = [{}];

  useEffect(() => {
    setTableData([props.data]);
    //ref to initial toggle state of show open orders on top
    OpenOrdsTopRef.current = true;
    // check that props.data is not undefined/null, group it(open and others) and update tabledata
    if (props.data.length) {
      if (!props.isHistory && OpenOrdsTopRef.current) {
        let temp0 = HOb2DGroupBy(props.data, "sts");
        exeCountRef.current = temp0[1].length;
        setTableData(temp0);
      }
    }
  }, [props.data, props.isHistory]);

  if (props.isHistory) {
    CommHistoryData = tableData.map((group) =>
      HObGroupBy(group, "ordEntTyp", " ")
    );
  }
  const [sortedColumnState, setSortedColumnState] = useState({
    colName: null as string | null,
    sortState: eSortState.ASC,
  });

  //selected count
  const [selectedCount, setselectedCount] = useState<number>(0);

  // state for mf popup handling
  const [popupDataIndex, setPopupDataIndex] =
    useState<[number, number, string?]>();

  // show cancel popup
  const [showCancelPopup, setShowCancelPopup] =
    React.useState<{ bulkCancel: boolean; data?: any }>();

  function onSort(data: Array<Array<any>>, sortState: eSortState) {
    setSortedColumnState({ colName: heading.symbol, sortState: sortState });
    setTableData(data);
    OpenOrdsTopRef.current = false;
  }

  const selectRows = (groupIndex: number, index: number) => {
    const retRes = obtradeRowSelection(
      groupIndex,
      index,
      tableData,
      isAllDataSelected,
      "cancel",
      "true"
    );

    // set the state
    setTableData(retRes.data);
    setselectedCount(retRes.count);

    setIsAllDataSelected(retRes.allSelected);
  };

  function onDataFilter(data: Array<any>, sText?: string, type?: string) {
    filteredData = data;

    // sort only if colName is present, otherwise there is no need to sort
    if (sortedColumnState.colName) {
      const colNameKey = Object.keys(heading).find(
        (key) => heading[key] === sortedColumnState.colName
      )!;
      sort(data, sortedColumnState.sortState, sortKey[colNameKey], onSort);
    }
    //highlightes the search text
    if (sText) {
      const SearchText: string = sText.toLowerCase();
      const searchKeys: string = "symName;trdSym";

      data[0].forEach((ord: indexer) => {
        searchKeys.split(";").forEach((k: string) => {
          if (ord[k]) {
            ord[k] = SearchHighLight(ord[k], SearchText);
          }
        });
      });
    }
    if (type === "search" && OpenOrdsTopRef.current && !props.isHistory) {
      setTableData(HOb2DGroupBy(data[0], "sts"));
    } else {
      setTableData(data);
    }
  }

  // this function excute on clicking any row
  function onRowClick(
    data: ICommodity,
    groupIndex: number,
    index: number,
    e?: any
  ) {
    if (
      e &&
      !e.nativeEvent.path.find(
        (m: HTMLElement) =>
          m.className &&
          (m.className.indexOf("check") >= 0 ||
            m.className.indexOf("menu") >= 0)
      )
    ) {
      setPopupDataIndex([
        groupIndex,
        index,
        props.isHistory && data.ordEntTyp
          ? data.ordEntTyp.split(" ")[0]
          : undefined,
      ]);
    }
  }
  function optSelection(id: string | number, data: any) {
    switch (id) {
      case "details":
      case "convert":
        setPopupDataIndex([
          data.gI,
          data.ind,
          props.isHistory && data.ord.ordEntTyp
            ? data.ord.ordEntTyp.split(" ")[0]
            : undefined,
        ]);
        break;
      case "cancel":
        checkPartialOrder(false, data.ord as ICommodity);
        break;
      default:
        //console.log("404");
        break;
    }
  }
  function addFlAndNtQty(bulkCancel: boolean, data?: ICommodity) {
    let flQtySum = 0;
    let ntQtySum = 0;

    if (bulkCancel) {
      tableData.forEach((g: any) =>
        g.forEach((rw: ICommodity) => {
          if (rw.isSelected) {
            flQtySum += +rw.flQty;
            ntQtySum += +(rw.ntQty ? rw.ntQty : rw.qtyTF || 0);
          }
        })
      );
    } else if (data) {
      flQtySum += +data.flQty;
      ntQtySum += +(data.ntQty ? data.ntQty : data.qtyTF || 0);
    }

    return { flQtySum, ntQtySum };
  }

  function selectedRows(bulkCancel: boolean, data?: ICommodity) {
    if (bulkCancel) {
      let total = 0;
      tableData.forEach((g: any) =>
        g.forEach((rw: ICommodity) => {
          if (rw.isSelected) {
            total++;
          }
        })
      );
      return total;
    } else if (data) {
      return 1;
    }
    return 0;
  }

  let ordCancelledSuccList: Array<string> = [],
    ordCancelledFailList: Array<string> = [],
    ordsListToCancel: Array<string> = [];

  // runs after all cancel api response
  function cancelCallback(res: any) {
    if (res.data) {
      // if success
      ordCancelledSuccList.push(res.data);
    } else {
      // if error
      ordCancelledFailList.push(res.error);
    }

    // when we get all the responses
    if (
      ordCancelledSuccList.length + ordCancelledFailList.length ===
      ordsListToCancel.length
    ) {
      setShowCancelPopup(undefined); // close confirmation popup
      //show toast message
      ee.emit("showToast", {
        message: `Cancelled ${ordsListToCancel.length} Orders`,
        color: "cancell",
      });

      props.reRenderCall && props.reRenderCall("today");
    }
  }

  function checkPartialOrder(bulkCancel: boolean, data?: ICommodity) {
    // <span>{data.flQty}</span>/<span>{data.ntQty ? data.ntQty : data.qtyTF}</span>
    const { flQtySum, ntQtySum } = addFlAndNtQty(bulkCancel, data);

    if (flQtySum === ntQtySum) {
      // not partially completed
      cancelOrder(bulkCancel, data?.ordID);
    } else {
      // partially completed
      setShowCancelPopup({ bulkCancel, data });
    }
  }

  function cancelOrder(bulkCancel: boolean, data?: any) {
    if (bulkCancel) {
      tableData.forEach((g: any) =>
        g.forEach((rw: ICommodity) => {
          if (rw.isSelected) {
            ordsListToCancel.push(rw.ordID);
            if (rw.ogt === "AMO") {
              // if amo trade then run this api
              ACommCancelAmoTrd(cancelCallback, {
                nstOID: rw.ordID,
                exc: rw.exc,
                ordTyp: rw.ordTyp,
                prdCode: rw.prdCode,
              });
            } else {
              // if normal trade then run this api
              ACommCancelNrmTrd(cancelCallback, {
                nstOID: rw.ordID,
                exc: rw.exc,
                ordTyp: rw.ordTyp,
                prdCode: rw.prdCode,
              });
            }
          }
        })
      );
    } else if (data) {
      // cancel single order
      ordsListToCancel.push(data?.ordID);
      if (data.ogt === "AMO") {
        // if amo trade then run this api
        ACommCancelAmoTrd(cancelCallback, {
          nstOID: data.ordID,
          exc: data.exc,
          ordTyp: data.ordTyp,
          prdCode: data.prdCode,
        });
      } else {
        // if normal trade then run this api
        ACommCancelNrmTrd(cancelCallback, {
          nstOID: data.ordID,
          exc: data.exc,
          ordTyp: data.ordTyp,
          prdCode: data.prdCode,
        });
      }
    }
  }

  function commRow(
    data: ICommodity,
    groupIndex: number,
    index: number,
    date?: string
  ) {
    return (
      <li
        className="comm_data ins_data"
        key={index}
        onClick={(e) => onRowClick(data, groupIndex, index, e)}
      >
        {isSelectEnable && (
          <div className="col check dtl_popup_action">
            {data.ovrOpts && data.cancel === "true" && (
              <ObCheckbox
                name="CommTradeSelect"
                checked={data.isSelected}
                onChange={() => selectRows(groupIndex, index)}
              />
            )}
          </div>
        )}
        <div className="col time">
          <span>
            {isSelectEnable && (
              <Tag
                value={data.trsTyp}
                cn="mob_text_tag"
                color={data.trsTyp === "BUY" ? "green" : "red"}
              />
            )}

            {data.rcvTim}
            {data.ordEntTyp &&
              moment(dateTimeFormat(data.ordEntTyp)).format("HH:mm:ss")}
          </span>
        </div>
        <div className="col txn_typ">
          <span>
            <Tag
              value={data.trsTyp[0]}
              shape="mini_circle"
              color={data.trsTyp === "BUY" ? "green" : "red"}
              height="22px"
              width="22px"
            />
          </span>
        </div>
        <div className="col sym">
          <span
            dangerouslySetInnerHTML={{
              __html: data.symName ? data.symName : data.trdSym,
            }}
          ></span>
          <p
            className="sym_code"
            dangerouslySetInnerHTML={{ __html: data.trdSym }}
          ></p>
        </div>
        <div className="col prod_typ">
          <span>{data.prdCode}</span>
        </div>
        <div className="col qty taRight">
          <span>{data.flQty}</span>
          {data.ntQty ||
            (data.qtyTF && (
              <span>/{data.ntQty ? data.ntQty : data.qtyTF}</span>
            ))}
        </div>
        {/* don't show order price in case of history data */}
        {!props.isHistory && (
          <div className="col odr_prc taRight">
            <span>{data.prc ? "₹" + toINR(data.prc, 2) : "--"}</span>
          </div>
        )}
        <div className="col avg_prc taRight">
          <span>
            {data.avgPrc && data.avgPrc !== "--"
              ? "₹" + toINR(data.avgPrc, 2)
              : "--"}
          </span>
        </div>
        {!props.isHistory && (
          <div className="col amo">
            <span>{data.ogt && data.ogt !== "--" ? data.ogt : ""}</span>
          </div>
        )}
        <div className="col sts">
          <span>
            <Tag
              value={ChipStatusComb[data.sts.toLowerCase()]}
              shape="chip"
              color={ChipColorKeyComb[data.sts]}
            />
          </span>
        </div>
        {!isSelectEnable && !props.isHistory && (
          <div className="col menu">
            {data.ovrOpts && (
              <OverflowButton
                defaultValue={"modify"}
                dropdownOptions={data.ovrOpts}
                onSelect={(id, data) => optSelection(id, data)}
                onHover={true}
                data={{
                  ord: data,
                  gI: groupIndex,
                  ind: index,
                }}
              />
            )}
          </div>
        )}
      </li>
    );
  }
  return (
    <>
      {/* UH start*/}
      {!isSelectEnable && (
        <ObUtilHeader
          leftSideText={
            !props.isHistory ? (
              <div className="executed">
                <span className="text">Executed Orders: </span>
                <span className="value">
                  {exeCountRef.current} / {initialData[0].length}
                </span>
              </div>
            ) : props.isHistory ? (
              <DatePickerInt plusDays={15} sendDates={props.getDates} />
            ) : (
              <></>
            )
          }
          data={initialData}
          searchKey="cpName;dpName;trdSym"
          onDataFilter={onDataFilter}
          onSelectClick={
            !props.isHistory &&
            tableData.find((g: any) =>
              g.find((row: ICommodity) => row.cancel === "true")
            )
              ? () => {
                  setIsSelectEnable(!isSelectEnable);
                }
              : undefined
          }
          onFilterClick={(tgl) => {
            OpenOrdsTopRef.current = tgl;
          }}
          filterReqData={{
            status: "sts",
            aType: "comm",
            showOpenOrderOnTop: OpenOrdsTopRef.current,
            showOpenOrderTgl: props.isHistory ? false : true,
            isHistory: props.isHistory ? true : false,
          }}
          onSearchClick={(e) => {
            // setTableData(initialData);
            // if exists, then call it
            props.hidePageNav && props.hidePageNav(e);
          }}
        />
      )}
      {/* UH end*/}

      {isSelectEnable && (
        <>
          <div className="util_cont util_select by2 mg-b30">
            <div className="vMid">
              <p className="selectedCount">{selectedCount} selected</p>
            </div>
            <div className="vMid taRight">
              <EdButton
                type="button"
                btnTyp="primary"
                value="Cancel Orders"
                slim={true}
                disabled={false}
                onClick={() => checkPartialOrder(true)}
              />
              <button
                onClick={() => setIsSelectEnable(false)}
                className="mg-l15 clsBtn edBtn"
              >
                Close
              </button>
            </div>
          </div>
        </>
      )}
      <div
        className={"comm_table ins_tabl" + (props.isHistory ? " history" : "")}
      >
        {/* ob Commodities Header Row */}
        {(!props.isHistory ||
          (props.isHistory && initialData[0].length > 0)) && (
          <ul className={scrlStCls.pOffset + " hdr_row"}>
            <li>
              {isSelectEnable && (
                <div className="col check">
                  <ObCheckbox
                    name="eqTradeSelect"
                    checked={isAllDataSelected}
                    onChange={() => selectRows(-1, -1)}
                  />
                </div>
              )}
              <div className="col time"> </div>
              <div className="col txn_typ"> </div>
              <div className="col sym">
                {!props.isHistory && (
                  <Sort
                    sortList={filteredData}
                    sortedColName={sortedColumnState.colName}
                    sortKey={sortKey.symbol}
                    onSort={onSort}
                    colName={heading.symbol}
                  />
                )}
                {props.isHistory && heading.symbol}
              </div>
              <div className="col prod_typ">{heading.prodType}</div>
              <div className="col qty taRight">{heading.qty}</div>
              {/* don't show order price in case of history data */}

              {!props.isHistory && (
                <div className="col odr_prc taRight">{heading.orderPrice}</div>
              )}
              <div className="col avg_prc taRight">{heading.avgPrice}</div>
              {!props.isHistory && <div className="col amo"> </div>}
              <div className="col sts"> </div>
              {!isSelectEnable && !props.isHistory && (
                <div className="col menu"> </div>
              )}
            </li>
          </ul>
        )}
        <div
          className={props.data.length > 0 ? "ObScrollCont" : ""}
          style={ObScrollStyle(props.data.length > 0 ? true : false)}
        >
          {/* ob Commodities content Row */}
          {props.isHistory ? (
            CommHistoryData.map((group, groupIndex) =>
              Object.keys(group).map((date, index) => {
                return (
                  <React.Fragment key={index}>
                    <ul
                      className={scrlStCls.freeze + " eq_hist_date hist_date"}
                      key={"dtGp" + index}
                    >
                      <li>
                        {moment(dateTimeFormat(date)).format("DD MMMM YYYY")}
                      </li>
                    </ul>
                    <ul className={scrlStCls.toContext} key={"dtUlDet" + index}>
                      {group[date].map((row: any, index: number) =>
                        commRow(row, groupIndex, index, date)
                      )}
                    </ul>
                  </React.Fragment>
                );
              })
            )
          ) : (
            <>
              {
                !!tableData.length &&
                  tableData.map((group: any, groupIndex: number) =>
                    // Object.keys(group).map((grp: any, index) =>
                    {
                      return (
                        <React.Fragment key={groupIndex}>
                          {group.length > 0 && (
                            <ul
                              key={groupIndex}
                              className={"blockDivider child" + groupIndex}
                            >
                              {/* {tableData.map((group, groupIndex) => */}
                              {group.map((row: any, index: number) => (
                                <React.Fragment key={index}>
                                  {commRow(row, groupIndex, index)}
                                </React.Fragment>
                              ))}
                              {/* )} */}
                            </ul>
                          )}
                        </React.Fragment>
                      );
                    }
                  )
                // )
              }
              {!tableData.length && (
                <TocNoData data={initialData} callBackMeth={onDataFilter} />
              )}
            </>
          )}
        </div>
        {popupDataIndex && (
          <ObAssetDetailPopup>
            <ObCommodityDtls
              data={
                props.isHistory
                  ? CommHistoryData[popupDataIndex[0]][popupDataIndex[2]!][
                      popupDataIndex[1]
                    ]
                  : tableData[popupDataIndex[0]][popupDataIndex[1]]
              }
              onBackClick={() => setPopupDataIndex(undefined)}
              isTodayOrder={!props.isHistory}
              onCancelClick={() =>
                checkPartialOrder(
                  false,
                  tableData[popupDataIndex[0]][popupDataIndex[1]] as ICommodity
                )
              }
            />
          </ObAssetDetailPopup>
        )}
        {showCancelPopup && (
          <ObAssetDetailPopup>
            <ObToastMessPopup
              title={`Cancel ${selectedRows(
                showCancelPopup.bulkCancel,
                showCancelPopup.data
              )} Orders`}
              subtitle={`${
                addFlAndNtQty(showCancelPopup.bulkCancel, showCancelPopup.data)
                  .flQtySum
              }/${
                addFlAndNtQty(showCancelPopup.bulkCancel, showCancelPopup.data)
                  .ntQtySum
              } quantities have been partially executed. Are you sure you want to cancel the order?`}
              buttonValue="Yes, Confirm"
              btnTyp="secondary"
              onBackClick={() => setShowCancelPopup(undefined)}
              onToastBtnClick={() =>
                cancelOrder(showCancelPopup.bulkCancel, showCancelPopup.data)
              }
            />
          </ObAssetDetailPopup>
        )}
      </div>
    </>
  );
};

export default ObCommodities;
